import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=099b61ee&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=099b61ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099b61ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('099b61ee')) {
      api.createRecord('099b61ee', component.options)
    } else {
      api.reload('099b61ee', component.options)
    }
    module.hot.accept("./teacher.vue?vue&type=template&id=099b61ee&scoped=true", function () {
      api.rerender('099b61ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantAccount/teacher.vue"
export default component.exports